import axios from 'axios';

export default {
  runPipeline({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/gitlab/runPipeline`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('runPipelineRequestSuccess', resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit('runPipelineRequestError', err);
          reject(err);
        });
    });
  },
  getPipelines({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/gitlab/getPipelines`,
        params: ctx.filter,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertPipelines', resp.data?.data || []);
          resolve(resp);
        })
        .catch(err => {
          commit('insertPipelinesRequestError', err);
          reject(err);
        });
    });
  },
  deletePipeline({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/gitlab/deletePipeline`,
        data: ctx.id,
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deletePipelineRequestSuccess', resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit('deletePipelineRequestError', err);
          reject(err);
        });
    });
  }
};
